import { DISCUSSION_BOARD_PATH } from "@/lib/constants";
import { cn } from "@/lib/utils";
import { ChevronRightIcon } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import LeadingOnlineForumStats from "./components/leading-online-forum-stats";

const LeadingOnlineForum = () => {
	const coverImage = `${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/home/leading-online-forum/leading-forum-background.png`;

	return (
		<div className="relative my-12 block h-auto w-full rounded-2xl shadow-md md:flex md:max-w-full md:flex-col md:items-center md:justify-center">
			<div className="absolute inset-0 rounded-2xl bg-brand-primary" />

			<div
				className="relative z-10 flex h-full w-full justify-end bg-cover bg-center bg-no-repeat p-4 md:p-0"
				style={{ backgroundImage: `url(${coverImage})` }}
			>
				<div className="flex flex-col items-center justify-center gap-2 py-6 md:w-1/2 md:pr-6 md:text-center">
					<div className="flex flex-col items-center gap-2 text-center">
						<div className="relative">
							<h4 className="text-center text-xl font-bold text-white md:text-2xl">
								The leading online forum where the global proptech & real estate community engages.
							</h4>

							<Image
								src={`${process.env.NEXT_PUBLIC_ASSETS_BASE_PREFIX}/static-files/home/leading-online-forum/butterfly-icon.png`}
								alt="Butterfly Logo"
								width={480}
								height={480}
								className="absolute -right-2 top-8 -z-10 h-16 w-16 -translate-y-1/2"
							/>

							<p className="mx-auto mt-2 px-4 pr-4 text-sm text-white">
								From Cambodia to Canada - one place where global proptech & real estate
								professionals connect, converse and collaborate.
							</p>

							<LeadingOnlineForumStats />
						</div>
					</div>

					<div className=" flex items-center gap-2">
						<Link
							href={DISCUSSION_BOARD_PATH}
							target="_blank"
							className={cn(
								"flex items-center rounded bg-[#FFA804] px-8  py-2 text-sm font-semibold text-white transition"
							)}
						>
							Join Discussion
							<ChevronRightIcon className="h-4 w-4" />
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
};

export default LeadingOnlineForum;
